<template>
    <div class="content">
        <container-top></container-top>
        <container-main></container-main>
        <container-bottom :custom-background="isHome"></container-bottom>
    </div>
</template>

<script>
import ContainerTop from "./ContainerTop";
import ContainerMain from "./ContainerMain";
import ContainerBottom from "./ContainerBottom";
export default {
    name: 'index',
    components: {
        ContainerTop,
        ContainerMain,
        ContainerBottom
    },
    data() {
        return {
            isHome: true
        }
    },
    mounted() {
        this.$router.afterEach(() => {
            this.isHome = this.$route.path.indexOf('views') === -1 || this.$route.path.indexOf('home') !== -1 || this.$route.path.indexOf('astrolink') !== -1;
            console.log(this.isHome);
        })
    },
    methods: {
    }
}
</script>

<style scoped>
.content {
    width: 100%;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/layout/index.vue